import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { portalApi } from "@/lib/portalApi";
import { usePortalAuth } from "@/portal/PortalAuth";

export default function PortalLoginPage() {
  const { isAuthenticated, loading, setUser } = usePortalAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && isAuthenticated) return <Navigate to="/portal" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const data = await portalApi.login({ email, password });
      if (data.requires_otp) {
        navigate("/portal/otp", { state: { email: data.email } });
        return;
      }
      setUser(data.user);
      navigate("/portal");
    } catch (err) {
      setError(err.message || "Sign in failed.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="portal-shell--auth">
      <form className="portal-form portal-form--auth" onSubmit={onSubmit}>
        <p className="eyebrow" style={{ color: "rgba(255,255,255,0.45)" }}>
          Portal
        </p>
        <h1 style={{ fontFamily: "var(--font-display)", letterSpacing: "-0.04em", marginBottom: "0.35rem" }}>Sign in</h1>
        <p style={{ color: "rgba(255,255,255,0.55)", marginBottom: "1rem", fontSize: "0.92rem" }}>
          Email and password, then a one-time code.
        </p>
        {error && <div className="portal-alert portal-alert--error">{error}</div>}
        <label>
          Email
          <input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <div className="portal-actions">
          <button className="btn" type="submit" disabled={submitting}>
            {submitting ? "Checking…" : "Continue"}
          </button>
        </div>
        <p style={{ marginTop: "1rem", fontSize: "0.85rem", color: "rgba(255,255,255,0.45)" }}>
          No account?{" "}
          <Link to="/portal/signup" style={{ textDecoration: "underline" }}>
            Signup
          </Link>
        </p>
      </form>
    </div>
  );
}
